<template>
  <div class="ability-index">
    <div class="flex flex-between my-3">
      <h4 class="page-title">能力框架列表</h4>
      <el-button type="primary" @click="handleAdd">新增</el-button>
    </div>
    <el-card class="">
      <el-table :data="tableData" :show-header="false">
        <el-table-column class-name="name" prop="name" label="名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="name">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope"> 创建者：{{ scope.row.user_nickname }} </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope"> 指标数：{{ scope.row.indicator_counts }} </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope"> 课程引用数：{{ scope.row.course_counts }} </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope"> 状态：{{ scope.row.is_share ? '共享' : '私有' }} </template>
        </el-table-column>
        <el-table-column label="操作" width="230">
          <template slot-scope="scope">
            <el-button class="btn-detail" type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button class="btn-edit" type="text" size="small" @click="handleEdit(scope.row)" v-if="scope.row.edit_auth">编辑</el-button>
            <el-button class="btn-share" type="text" size="small" @click="handleShare(scope.row)"
              >设为{{ scope.row.is_share ? '私有' : '共享' }}</el-button
            >
            <el-button class="btn-delete" type="text" size="small" @click="handleDelete(scope.row)" v-if="scope.row.delete_auth">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-row v-if="this.totalSize > 0" class="flex-between flex-align-center mt-3">
      <el-col>
        <div>共{{ totalSize }}条数据</div>
      </el-col>
      <Pagination
        :pageSizes="[10, 20, 50, 100]"
        :perSize="pageSizesVal"
        :totalSize="totalSize"
        :currentPage="currentPage"
        @setPageSizesVal="getPageSizesVal"
        @setCurPageVal="getCurPageVal"
      ></Pagination>
    </el-row>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue'
export default {
  name: 'AbilityIndex',
  components: { Pagination },
  data() {
    return {
      tableData: [],
      // 页码数据
      totalSize: 0,
      currentPage: 1,
      pageSizesVal: 10,
    }
  },
  mounted() {
    this.getCapabilityFrame()
  },
  methods: {
    // 获取课程能力达成
    getCapabilityFrame() {
      this.$store
        .dispatch('capability/getCapabilityFrame', { page: this.currentPage, pagesize: this.pageSizesVal })
        .then((res) => {
          console.log('getCapabilityFrame:', res)
          if (res.code === 1) {
            this.tableData = res.data.list || []
            this.totalSize = res.data.paging.records
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    handleAdd() {
      this.$router.push({
        path: '/ability-framework/edit/0',
      })
    },
    handleView(row) {
      this.$router.push({
        path: '/ability-framework/detail/' + row.id,
      })
    },
    handleEdit(row) {
      this.$router.push({
        path: '/ability-framework/edit/' + row.id,
      })
    },
    handleShare(row) {
      this.$confirm(`确认 ${row.name} 设为${row.is_share ? '私有' : '共享'}？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.$store
            .dispatch('capability/updateCapabilityFrameStatus', { id: row.id, status: row.is_share ? 0 : 1 })
            .then((res) => {
              console.log('getCapabilityFrame:', res)
              if (res.code === 1) {
                this.$message({
                  type: 'success',
                  message: '设置成功',
                })
                this.getCapabilityFrame()
              }
            })
            .catch((err) => {
              console.log('err:', err)
            })
        })
        .catch(() => {})
    },
    handleDelete(row) {
      const h = this.$createElement
      const _this = this
      this.$msgbox({
        title: '提示',
        message: h('p', null, [
          h('span', null, `确认删除 ${row.name}？`),
          h('div', { style: 'color: red;text-align:center;' }, '删除后无法恢复。'),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            _this.$store
              .dispatch('capability/deleteCapabilityFrame', { id: [row.id] })
              .then((res) => {
                instance.confirmButtonLoading = false
                done()
                if (res.code === 1) {
                  this.$message({
                    type: 'success',
                    message: '删除成功',
                  })
                  this.getCapabilityFrame()
                }
              })
              .catch((err) => {
                console.log('err:', err)
              })
          } else {
            done()
          }
        },
      })
        .then(() => {})
        .catch(() => {})
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getCapabilityFrame()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getCapabilityFrame()
    },
  },
}
</script>
<style lang="scss" scoped>
.ability-index {
  .page-title {
    font-size: 20px;
    line-height: 20px;
    font-weight: bold;
  }
  ::v-deep .el-table {
    .cell {
      color: #6c757d;
      .el-button + .el-button,
      .el-checkbox.is-bordered + .el-checkbox.is-bordered {
        margin-left: 24px;
      }
      .el-button:not(:last-child) {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -13px;
          width: 1px;
          height: 12px;
          background-color: #e6e6e6;
        }
      }
      .btn-delete {
        color: #e32929;
      }
    }
    .name {
      .cell {
        font-weight: bold;
        color: #343a40;
      }
    }
  }
  .empty-course {
    height: 320px;
    background-color: white;
    background-repeat: no-repeat;
    background-clip: content-box;
    .empty-course-tips {
      margin-top: 24px;
      color: rgba(152, 166, 173, 1);
      font-size: 18px;
    }
  }
}
</style>
